export const MY_FLEET_STATE = "MY_FLEET";
